var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.625 1C5.625 0.723858 5.40114 0.5 5.125 0.5C4.84886 0.5 4.625 0.723858 4.625 1H5.625ZM4.625 13C4.625 13.2761 4.84886 13.5 5.125 13.5C5.40114 13.5 5.625 13.2761 5.625 13H4.625ZM3.25 1.5H10.75V0.5H3.25V1.5ZM12.5 3.25V10.75H13.5V3.25H12.5ZM10.75 12.5H3.25V13.5H10.75V12.5ZM1.5 10.75V3.25H0.5V10.75H1.5ZM3.25 12.5C2.2835 12.5 1.5 11.7165 1.5 10.75H0.5C0.5 12.2688 1.73122 13.5 3.25 13.5V12.5ZM12.5 10.75C12.5 11.7165 11.7165 12.5 10.75 12.5V13.5C12.2688 13.5 13.5 12.2688 13.5 10.75H12.5ZM10.75 1.5C11.7165 1.5 12.5 2.2835 12.5 3.25H13.5C13.5 1.73122 12.2688 0.5 10.75 0.5V1.5ZM3.25 0.5C1.73122 0.5 0.5 1.73122 0.5 3.25H1.5C1.5 2.2835 2.2835 1.5 3.25 1.5V0.5ZM4.625 1V13H5.625V1H4.625ZM1.375 5.625H12.625V4.625H1.375V5.625Z",
    fill: "#CFCED4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.85ea5a6fc725aa44504153fce58b9b3f.svg";
export { ForwardRef as ReactComponent };